import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

export type PurchasePhase = {
  id: "lane" | "mid" | "late";
  // Начало фазы, секунды от начала матча, включительно.
  fromS: number;
  // Конец фазы, не включительно; `null` — до конца матча.
  toS: number | null;
  label: MessageDescriptor;
};

// Фазы матча на таймлайне закупа, как в макете: линия, середина, поздняя игра.
export const PURCHASE_PHASES: readonly PurchasePhase[] = [
  {
    id: "lane",
    fromS: 0,
    toS: 10 * 60,
    label: msg({ id: "analysis.buy.phase.lane", message: "Lane · 0–10 minutes" }),
  },
  {
    id: "mid",
    fromS: 10 * 60,
    toS: 25 * 60,
    label: msg({ id: "analysis.buy.phase.mid", message: "Mid game · 10–25 minutes" }),
  },
  {
    id: "late",
    fromS: 25 * 60,
    toS: null,
    label: msg({ id: "analysis.buy.phase.late", message: "Late game · 25+ minutes" }),
  },
];
